import React from 'react';
import Footer from '../../layout/Footer';
import ViewSalesReturn from './ViewSalesReturn';
import NewQuickSalesReturn from './NewQuickSalesReturn';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';

// icon
import Icon from '@mdi/react';
import { mdiPlus, mdiReceiptTextOutline } from '@mdi/js';

export default function SalesReturn() {
    // Change card title
    const handleClick = event => {
        var buttonID = event.currentTarget.id;
        var button = document.getElementById(buttonID);
        var cardtitle = document.getElementById('cardTitle');
        var buttonText = button.textContent;
        cardtitle.innerHTML = buttonText;
    };

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col md={12}>
                                <Card>
                                    <Card.Body>
                                        <div className="d-md-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-md-0' id="cardTitle">View Sales Return</Card.Title>
                                            <div className="custom-top-nav-tab d-flex mt-3 mt-md-0">
                                                <ul className="nav nav-pills btn-list me-2" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button onClick={handleClick} className="nav-link active" id="pills-view-sales-return-tab" data-bs-toggle="pill" data-bs-target="#pills-view-sales-return" type="button" data-text="View Sales Return" role="tab" aria-controls="pills-view-sales-return" aria-selected="true">
                                                            <Icon path={mdiReceiptTextOutline} className="btn-icon me-1" />View Sales Return
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button onClick={handleClick} className="nav-link" id="pills-new-quick-sales-return-tab" data-bs-toggle="pill" data-bs-target="#pills-new-quick-sales-return" data-text="New Quick Sales Return" type="button" role="tab" aria-controls="pills-new-quick-sales-return" aria-selected="false">
                                                            <Icon path={mdiPlus} className="btn-icon me-1" />New Quick Sales Return
                                                        </button>
                                                    </li>
                                                </ul>
                                                <Form>
                                                    <Form.Select  size="sm">
                                                        <option>Year to date(YTD)</option>
                                                        <option value="1">All Time</option>
                                                        <option value="2">Two</option>
                                                    </Form.Select>
                                                </Form>
                                            </div>
                                        </div>

                                        <div className="tab-content" id="pills-tabContent">
                                            <div className="tab-pane fade show active" id="pills-view-sales-return" role="tabpanel" aria-labelledby="pills-view-sales-return-tab" tabIndex="0">
                                                <ViewSalesReturn />
                                            </div>
                                            <div className="tab-pane fade" id="pills-new-quick-sales-return" role="tabpanel" aria-labelledby="pills-new-quick-sales-return-tab" tabIndex="0">
                                                <NewQuickSalesReturn />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
